// routes/authRoutes.js
import Register from '../components/auth/Register';
import Login from '../components/auth/Login';
import PasswordReset from '../components/auth/PasswordReset';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Generic auth routes (not project-specific)
const GenericRegister = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('project') || 'default-project-id';

  const handleSuccess = () => {
    navigate('/login');
  };

  return <Register projectId={projectId} onSuccess={handleSuccess} />;
};

const GenericLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('project') || 'default-project-id';
  const returnUrl = searchParams.get('returnUrl') || '/';

  const handleSuccess = (data) => {
    navigate(returnUrl);
  };

  return <Login projectId={projectId} onSuccess={handleSuccess} />;
};

const GenericPasswordReset = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('project') || 'default-project-id';

  const handleSuccess = () => {
    navigate('/login');
  };

  return <PasswordReset projectId={projectId} onSuccess={handleSuccess} />;
};

const authRoutes = [
  { 
    path: '/register', 
    element: <GenericRegister /> 
  },
  { 
    path: '/login', 
    element: <GenericLogin /> 
  },
  { 
    path: '/forgot-password', 
    element: <GenericPasswordReset /> 
  }
];

export default authRoutes;